export default __webpack_public_path__ + "static/media/ExpensesTab.557ad519.xlsx";